import React, {useEffect, useRef} from 'react';

import './AppWrapper.scss';
import {useLevity} from '../../hooks/index';
import {VCF} from '../';
import {AnimatedEllipsis} from '../../components';
import {IAM_LOGIN_URL} from '../../constants/global';
import {initializeGlobalVariable} from '../../services/analytics/analytics';

export function handleSkipLinkClick(e, ref) {
  e.preventDefault();
  if (e.type === 'click' || e.charCode === 13 || e.keyCode === 13) {
    ref.current.scrollIntoView();
    ref.current.setAttribute('tabindex', '-1');
    ref.current.focus();
  }
}

/**
 * App wrapper. Handles all initial calls.
 * @return {ReactElement} HTML markup
 */
export const AppWrapper = () => {
  const mainContentRef = useRef(null);
  useEffect(() => {
    // eslint-disable-next-line new-cap
    cb.apricot.CBInputMethod().init();
    //CBModal.init({});
  }, []);
  useEffect(() => {
    initializeGlobalVariable();
  }, []);

  const {loggingIn, loggedIn, catapultError, invalidClockError, timedOut} = useLevity();

  if (loggingIn) {
    return (
      <div className='bf-app-wrapper-ellipsis-wrapper'>
        <h4>Logging in</h4>
        <AnimatedEllipsis />
      </div>
    );
  }

  if (!loggedIn) {
    if(invalidClockError===true) {
      setTimeout(() => {
        window.location.replace(`${IAM_LOGIN_URL}bfcp-dashboard`);
      }, 7000);
      return (
        <div className='bf-app-wrapper-ellipsis-wrapper'>
          <h4>Your collegeboard Session has expired. <br /><br />You will be redirected back to the login page.</h4>
          <AnimatedEllipsis />
        </div>
      );
    } else {
      window.location.replace(`${IAM_LOGIN_URL}bfcp-dashboard`);
      return (
        <div className='bf-app-wrapper-ellipsis-wrapper'>
          <h4>Authentication in progress</h4>
          <AnimatedEllipsis />
        </div>
      );
    }
  }

  return (
    <div className='main-content' id='main-content' ref={mainContentRef}>
      <VCF
        catapultError={catapultError}
        invalidClockError={invalidClockError}
        timedOut={timedOut}
        isLoggedIn={loggedIn}
      />
    </div>
  );
};

export default AppWrapper;